import { apiRecords } from '../api';
import { ComplaintSuggestionResponse } from './types';

export const HINTS_PATH = '/v1/recordmeta/COMPLAINT/hints';
export const FAVORITES_PATH = '/v1/recordmeta/COMPLAINT/favorites';

export const getComplaintsSearch = (term: string) =>
  apiRecords.get(HINTS_PATH, {
    params: {
      search_str: term,
    },
  });

export const getComplaintsSuggestions = () => apiRecords.get(FAVORITES_PATH);

export const postSuggestionToFavorites = (
  complaintSuggestion: ComplaintSuggestionResponse,
) => apiRecords.post(FAVORITES_PATH, complaintSuggestion);
